<!--
 * @Description: 直播限制问卷
 * @Date: 2021-02-03 17:57:37
-->
<template>
  <div style="padding-bottom:1rem;">
    <img :src="checkInfo.image" alt width="100%" />
    <van-form @submit="confirm" label-width="60px">
      <ul>
        <li v-for="(item, index) in question" :key="index" class="custom-field">
          <!-- v-if="![3,4,5].includes(item.type)" -->

          <van-field
            v-model.trim="item.value"
            class="itemBox"
            :maxlength="30"
            :label="item.name + ':'"
            :required="item.request == 1"
            :rules="
            setRule(item.type,item.request)
         
            "
          ></van-field>
          <!-- <van-field
            v-if="item.type == 3"
            v-model="item._value"
            readonly
            class="itemBox"
            right-icon="arrow"
            @click="toHospital(item)"
            :label="item.name + ':'"
            :required="item.request == 1"
            :rules="item.request == 1?rules[3]:[]"
          ></van-field>
          <van-field
            v-if="item.type == 4"
            v-model="item._value"
            readonly
            class="itemBox"
            right-icon="arrow"
            @click="showToast('dep',item)"
            :label="item.name + ':'"
            :required="item.request == 1"
            :rules="item.request == 1?rules[4]:[]"
          ></van-field>
          <van-field
            v-if="item.type == 5"
            v-model="item._value"
            readonly
            class="itemBox"
            right-icon="arrow"
            @click="showToast('duty',item)"
            :label="item.name + ':'"
            :required="item.request == 1"
            :rules="item.request == 1?rules[5]:[]"
          ></van-field> -->
        </li>
      </ul>
      <div style="margin-top: 16px;">
        <van-button class="btn" block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
    <van-popup v-model="show" position="bottom" class="showPop">
      <van-picker
        v-if="type === 'dep'"
        show-toolbar
        title="请选择科室"
        :columns="departmentList"
        @cancel="show = false"
        value-key="name"
        @confirm="confirmDep"
      />
      <van-picker
        v-else
        value-key="name"
        show-toolbar
        title="请选择职称"
        :columns="dutyList"
        @cancel="show = false"
        @confirm="confirmDut"
      />
    </van-popup>
    <div class="fixed" v-if="showHospital">
      <chooseHospital
        :isComponent="true"
        @change="confirmHospital"
        @cancel="showHospital = false"
      ></chooseHospital>
    </div>
  </div>
</template>

<script>
import { customerUser, dicBase, fileUpload, updateHeadPhoto } from '@/api/ajax';
import chooseHospital from '../../perfect/chooseHospital';
import { addByWatchCheck } from '@/api/course';
import { mapMutations } from 'vuex';
import { setStorage, syncUserInfo } from '@/utils/storage';
import { easyCopy } from '@/utils';

export default {
  name: 'LivingSurvey',
  data() {
    return {
      _item: {},
      show: false,
      showHospital: false,
      type: 'dep',
      dutyList: [],
      departmentList: [],
      question: []
    };
  },
  components: { chooseHospital },
  watch: {
    checkInfo: {
      handler(v) {
        if (v.quesqionJson) {
          const question = v.quesqionJson;
          question.forEach(item => {
            item.value = '';
          });
          this.question = easyCopy(question);
        }
      },
      immediate: true
    }
  },
  computed: {
    rules() {
      return;
    },
    checkInfo() {
      return this.$store.state.living.checkInfo;
    },
    hospitalInfo() {
      return this.$store.state.register.hospitalInfo || {};
    }
  },
  methods: {
    ...mapMutations(['SET_PERFECT']),
    setRule(type, required) {
      const _required = !!required
      const mapping = {
        1: [{ required: true, message: '请输入昵称' }],
        2: [
          {
            validator: v => {
              if (!_required && !v.length) {
                return true;
              }
              return /^1[0-9]{10}$/.test(`${v}`);
            },
            message: '请输入正确的手机号'
          }
        ],
        3: [{ required: true, message: '请选择医院' }],
        4: [{ required: true, message: '请选择科室' }],
        5: [{ required: true, message: '请选择职称' }],
        6: [{ required: true, message: '请输入' }]
      };
      const ruleObj = {...mapping[type][0],required:_required}
      return [ruleObj]
    },
    toHospital(item) {
      this._item = item;
      this.showHospital = true;
    },
    confirmHospital(item) {
      const { id, fullName } = item;
      this._item.value = id;
      this._item._value = fullName;
      this.showHospital = false;
    },
    confirmDep(item, id) {
      this._item.value = this.departmentList[id[0]].children[id[1]].id;
      this._item._value = item.join('-');
      this.show = false;
    },
    confirmDut(item) {
      const { id, name } = item;
      this._item.value = id;
      this._item._value = name;
      this.show = false;
    },
    showToast(type, item) {
      this._item = item;
      this.type = type;
      this.show = true;
    },
    async confirm() {
      try {
        const { data } = await addByWatchCheck({
          courseId: this.checkInfo.courseId,
          authId: this.checkInfo.id,
          answer: JSON.stringify(this.question)
        });
        // 设置是否提交过问卷 （用于未登录用户）
        // setStorage('hideLiveSurvey', this.checkInfo.courseId);
        // 有用户信息的则同步

        this.$store.dispatch('living/init');
        this.$toast('提交成功');
      } catch (error) {}
    }
  },
  created() {
    // dicBase.departmentList().then(res => {
    //   this.departmentList = res.data.data;
    // });
    // dicBase.dutyList().then(res => {
    //   this.dutyList = res.data.data;
    // });
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.custom-field {
  .van-cell {
    overflow: inherit;
  }
  .van-field--error .van-field__control {
    &::-webkit-input-placeholder {
      color: #969799;
    }
  }
  .van-field__control {
    color: #333;
  }
  .van-field__value {
    position: relative;
    .van-field__control {
      font-size: 0.38rem;
    }
    .van-field__error-message {
      position: absolute;
      left: 0;
      line-height: 2.5;
    }
  }
}
</style>
<style scoped lang="scss">
.van-form {
  width: 7.56rem;
  margin: 0 auto;
  margin-top: 0.55rem;
  ul {
    li {
      border: 1px solid rgba($color: #a1a1a1, $alpha: 0.26);
      & + li {
        margin-top: 0.57rem;
      }
      & > div {
        padding: 5px 16px;
      }
    }
  }
  .btn {
    width: 100%;
    height: 1.12rem;
    background: linear-gradient(182deg, #5cc4ff, #004eee);
    border-radius: 0.2rem;
    border: none;
  }
}
.fixed {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: #fff;
}
</style>
